<template>
  <div class="authincation section-padding">
    <div class="container h-100">
      <div class="row justify-content-center h-100 align-items-center">
        <div class="col-xl-5 col-md-6">
          <div class="auth-form card">
            <div class="card-header justify-content-center">
              <h4 class="card-title">ورود به سیستم</h4>
            </div>
            <div class="card-body">
              <form
                method="post"
                name="myform"
                class="signin_validate"
                action="otp-1.html"
              >
                <div class="form-group">
                  <label>ایمیل</label>
                  <input
                    type="email"
                    class="form-control"
                    placeholder="hello@example.com"
                    name="email"
                  />
                </div>
                <div class="form-group">
                  <label>کلمه عبور</label>
                  <input
                    type="password"
                    class="form-control"
                    placeholder="رمز خود را وارد نمایید"
                    name="password"
                  />
                </div>
                <div class="form-row d-flex justify-content-between mt-4 mb-2">
                  <div class="form-group mb-0">
                    <label class="toggle">
                      <input class="toggle-checkbox" type="checkbox" />
                      <span class="toggle-switch"></span>
                      <span class="toggle-label">مرا به خاطر بسپار</span>
                    </label>
                  </div>
                  <div class="form-group mb-0">
                    <a href="reset.html">فراموش کردید ؟</a>
                  </div>
                </div>
                <div class="text-center">
                  <button type="submit" class="btn btn-success btn-block">
                    ورود
                  </button>
                </div>
              </form>
              <div class="new-account mt-3">
                <p>
                  ثبت نام نکرده اید ؟
                  <!-- <a class="text-primary" href="signup.html">ثبت نام</a> -->
                  <router-link class="text-primary" to="/signup"
                    >ثبت نام</router-link
                  >
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  mounted() {
    // Toggle navigation on mobile
    if (window.innerWidth < 991) {
      var nav = document.querySelector(".navbar-collapse.collapse.show");
      if (nav != undefined) nav.classList.toggle("show");
    }
  },
};
</script>
